import FixedNav from "../components/Nav/FixedNav";
import MobileNav from "../components/Nav/MobileNav";
import Header from "../components/Description/Header";
import Title from "../components/Description/Title";
import Normal from "../components/Description/Normal";
import Big from "../components/Description/Big";

const Term = () => {
  return (
    <div id="body">
      <div className="framer-IqNBt framer-vrYYp framer-NrkXy framer-l50WH framer-V74Ls framer-uKIIJ framer-Fw2Wf framer-72rtr7 min-h-screen !w-auto">
        <FixedNav />
        <MobileNav />
        <div id="content" className="w-full mt-[60px] p-[20px]">
          <Header>Codeblaze AI Terms of Service</Header>
          <Normal>Last Updated: July 3, 2025</Normal>
          <div className="p-10" />

          <Title>1. Introduction and Acceptance</Title>
          <div className="p-3" />
          <Normal>
            Welcome to Codeblaze AI Inc. ("Codeblaze," "we," "us," or "our"). These Terms of Service ("Terms") govern your access to and use of our website at codeblaze.ai (the "Site"), our artificial intelligence-powered development platform, and all related services (collectively, the "Services").
          </Normal>
          <div className="p-3" />
          <Normal>
            By clicking "I Accept," or by accessing or using our Services, you agree to be bound by these Terms, our Privacy Policy, and all applicable laws and regulations. If you are using our Services on behalf of an organization, you represent and warrant that you have the authority to bind that organization to these Terms.
          </Normal>
          <div className="p-5" />

          <Title>2. Changes to These Terms</Title>
          <div className="p-3" />
          <Normal>
            We reserve the right to modify these Terms at any time. We will provide notice of material changes by posting the updated Terms on our Site or through other reasonable means. Your continued use of the Services after such changes constitutes your acceptance of the new Terms. We encourage you to review these Terms periodically.
          </Normal>
          <div className="p-5" />

          <Title>3. Eligibility</Title>
          <div className="p-3" />
          <Normal>
            To use our Services, you must:
            <br />- Be at least 18 years old
            <br />- Have the legal capacity to enter into binding contracts
            <br />- Not be barred from using our Services under applicable law
            <br />- Not be located in a country that is subject to a U.S. Government embargo, or that has been designated by the U.S. Government as a "terrorist supporting" country
          </Normal>
          <div className="p-5" />

          <Title>4. Our Services</Title>
          <div className="p-3" />
          <Big>4.1 Service Description</Big>
          <div className="p-3" />
          <Normal>
            Codeblaze provides an AI-powered development platform that helps users generate, modify, and optimize code. Our Services may include:
            <br />- Code generation tools
            <br />- Code analysis and optimization features
            <br />- Collaboration tools
            <br />- Integration with third-party services
            <br />- Documentation and support resources
          </Normal>
          <div className="p-3" />
          <Big>4.2 Service Modifications</Big>
          <div className="p-3" />
          <Normal>
            We are constantly innovating and improving our Services. We may add or remove features, functionalities, or content at any time without notice. We reserve the right to modify or discontinue, temporarily or permanently, our Services or any part thereof with or without notice.
          </Normal>
          <div className="p-3" />
          <Big>4.3 Access to Services</Big>
          <div className="p-3" />
          <Normal>
            Subject to these Terms, we grant you a limited, non-exclusive, non-transferable, revocable license to access and use our Services for your personal or commercial use. This license is subject to the following restrictions:
            <br />- You may not use our Services for any illegal or unauthorized purpose
            <br />- You may not use our Services to develop any software or applications that violate applicable laws or regulations
            <br />- You may not use our Services to develop any software or applications that are harmful, misleading, or deceptive
            <br />- You may not use our Services to develop any software or applications that infringe upon the rights of any third party
          </Normal>
          <div className="p-5" />

          <Title>5. Your Account</Title>
          <div className="p-3" />
          <Big>5.1 Account Registration</Big>
          <div className="p-3" />
          <Normal>
            To access certain features of our Services, you may need to create an account. When you create an account, you agree to:
            <br />- Provide accurate, complete, and up-to-date information
            <br />- Maintain the security and confidentiality of your account credentials
            <br />- Promptly update your account information if it changes
            <br />- Not share your account credentials with any third party
          </Normal>
          <div className="p-3" />
          <Big>5.2 Account Security</Big>
          <div className="p-3" />
          <Normal>
            You are responsible for maintaining the confidentiality of your account credentials and for all activities that occur under your account. You agree to immediately notify us of any unauthorized use of your account or any other breach of security. We will not be liable for any losses or damages arising from your failure to maintain the security of your account.
          </Normal>
          <div className="p-3" />
          <Big>5.3 Account Termination</Big>
          <div className="p-3" />
          <Normal>
            We reserve the right to suspend or terminate your account and access to our Services at any time, with or without cause, and with or without notice. Upon termination, your right to use our Services will immediately cease. We will not be liable to you or any third party for any termination of your access to our Services.
          </Normal>
          <div className="p-5" />

          <Title>6. User Content</Title>
          <div className="p-3" />
          <Big>6.1 Your Content</Big>
          <div className="p-3" />
          <Normal>
            You retain all rights to any content you create, upload, or submit to our Services ("User Content"). By submitting User Content to our Services, you grant us a worldwide, non-exclusive, royalty-free, sublicensable, and transferable license to use, reproduce, distribute, prepare derivative works of, display, and perform the User Content in connection with our Services.
          </Normal>
          <div className="p-3" />
          <Big>6.2 Content Guidelines</Big>
          <div className="p-3" />
          <Normal>
            You agree not to submit any User Content that:
            <br />- Violates any applicable laws or regulations
            <br />- Infringes upon the rights of any third party
            <br />- Is harmful, misleading, or deceptive
            <br />- Contains any malicious code or harmful components
            <br />- Is defamatory, obscene, or otherwise objectionable
          </Normal>
          <div className="p-3" />
          <Big>6.3 Content Removal</Big>
          <div className="p-3" />
          <Normal>
            We reserve the right to remove any User Content that violates these Terms or that we deem inappropriate or objectionable. We will not be liable for any removal of User Content from our Services.
          </Normal>
          <div className="p-5" />

          <Title>7. Intellectual Property</Title>
          <div className="p-3" />
          <Big>7.1 Our Intellectual Property</Big>
          <div className="p-3" />
          <Normal>
            Our Services and all related content, including but not limited to text, graphics, logos, button icons, images, audio clips, digital downloads, data compilations, and software, are the property of Codeblaze or our licensors and are protected by applicable intellectual property laws. You agree not to modify, reproduce, distribute, display, or create derivative works of any such content without our prior written consent.
          </Normal>
          <div className="p-3" />
          <Big>7.2 Your Intellectual Property</Big>
          <div className="p-3" />
          <Normal>
            You retain all rights to any code or applications you develop using our Services. We make no claim to ownership of any such code or applications. You are free to use, modify, and distribute any code generated through our platform for any purpose, commercial or otherwise, without any obligation to us.
          </Normal>
          <div className="p-3" />
          <Big>7.3 Feedback</Big>
          <div className="p-3" />
          <Normal>
            If you provide us with any feedback, suggestions, or ideas regarding our Services ("Feedback"), you agree that we may use such Feedback without any restriction or obligation to you. You further agree that we will own all rights to any Feedback you provide.
          </Normal>
          <div className="p-5" />

          <Title>8. Data Usage and Privacy</Title>
          <div className="p-3" />
          <Big>8.1 Data Collection</Big>
          <div className="p-3" />
          <Normal>
            We collect and process data to improve our Services, provide support, and enhance user experience. Our Privacy Policy explains in detail how we collect, use, and protect your information.
          </Normal>
          <div className="p-3" />
          <Big>8.2 Service Improvement</Big>
          <div className="p-3" />
          <Normal>
            We use aggregated and anonymized data to:
            <br />- Enhance our AI models and algorithms
            <br />- Improve the quality and accuracy of our Services
            <br />- Develop new features and capabilities
            <br />- Optimize performance and reliability
            <br />- Identify and resolve technical issues
          </Normal>
          <div className="p-3" />
          <Big>8.3 Enterprise Customers</Big>
          <div className="p-3" />
          <Normal>
            For our Enterprise plan customers, we offer enhanced data protection and control, including:
            <br />- Custom data handling agreements
            <br />- Advanced security and compliance features
            <br />- Dedicated support and account management
          </Normal>
          <div className="p-3" />
          <Big>8.4 Data Retention</Big>
          <div className="p-3" />
          <Normal>
            We retain your data only as long as necessary to provide our Services and for legitimate business purposes. You may request the deletion of your data at any time, subject to our retention policies and technical feasibility.
          </Normal>
          <div className="p-5" />

          <Title>9. Pricing and Payment</Title>
          <div className="p-3" />
          <Big>9.1 Subscription Plans</Big>
          <div className="p-3" />
          <Normal>
            We offer various subscription plans with different features and limits. You can find detailed information about our plans and pricing on our website at codeblaze.ai/pricing.
          </Normal>
          <div className="p-3" />
          <Big>9.2 Payment Terms</Big>
          <div className="p-3" />
          <Normal>
            Our Services are provided on a subscription basis with recurring billing. By subscribing to a paid plan, you authorize us to charge the applicable fees to your payment method on a recurring basis until you cancel your subscription.
          </Normal>
          <div className="p-3" />
          <Big>9.3 Free Trial</Big>
          <div className="p-3" />
          <Normal>
            We may offer free trials of our paid plans. Free trials are subject to the following terms:
            <br />- Free trials are limited to one per customer
            <br />- Free trials are subject to automatic conversion to a paid subscription unless canceled before the end of the trial period
            <br />- We reserve the right to modify or discontinue free trials at any time
          </Normal>
          <div className="p-3" />
          <Big>9.4 Refund Policy</Big>
          <div className="p-3" />
          <Normal>
            All payments for our Services are final and non-refundable. This includes but is not limited to:
            <br />- Subscription fees
            <br />- Credit purchases
            <br />- Renewal charges
            <br />- Any other fees associated with our Services
          </Normal>
          <div className="p-3" />
          <Normal>
            We do not offer refunds for any unused portion of your subscription or for any unused credits. By making a purchase, you acknowledge and agree to this no-refund policy.
          </Normal>
          <div className="p-3" />
          <Big>9.5 Taxes</Big>
          <div className="p-3" />
          <Normal>
            You are responsible for paying any applicable taxes associated with your use of our Services. We will collect and remit any applicable sales taxes as required by law.
          </Normal>
          <div className="p-5" />

          <Title>10. Prohibited Conduct</Title>
          <div className="p-3" />
          <Normal>
            You agree not to:
            <br />- Use our Services for any illegal or unauthorized purpose
            <br />- Violate any applicable laws or regulations in your use of our Services
            <br />- Infringe upon the rights of any third party in your use of our Services
            <br />- Interfere with or disrupt the operation of our Services
            <br />- Use any automated means to access or use our Services
            <br />- Attempt to gain unauthorized access to our systems or networks
            <br />- Upload or transmit any malicious code or harmful components
            <br />- Use our Services to develop any software or applications that are harmful, misleading, or deceptive
            <br />- Use our Services to develop any software or applications that violate applicable laws or regulations
            <br />- Use our Services to develop any software or applications that infringe upon the rights of any third party
            <br />- Use our Services in any manner that could damage, disable, overburden, or impair our Services
            <br />- Use our Services to transmit any unsolicited or unauthorized advertising, promotional materials, or any other form of solicitation
            <br />- Use our Services to harvest or collect any information about other users without their express consent
          </Normal>
          <div className="p-5" />

          <Title>11. Third-Party Services</Title>
          <div className="p-3" />
          <Normal>
            Our Services may contain links to third-party websites or services that are not owned or controlled by us. We have no control over, and assume no responsibility for, the content, privacy policies, or practices of any third-party websites or services. You acknowledge and agree that we will not be responsible or liable, directly or indirectly, for any damage or loss caused or alleged to be caused by or in connection with the use of or reliance on any such content, goods, or services available on or through any such third-party websites or services.
          </Normal>
          <div className="p-5" />

          <Title>12. Disclaimers</Title>
          <div className="p-3" />
          <Normal>
            OUR SERVICES ARE PROVIDED "AS IS" AND "AS AVAILABLE" WITHOUT WARRANTIES OF ANY KIND, EITHER EXPRESS OR IMPLIED. WE DISCLAIM ALL WARRANTIES, INCLUDING BUT NOT LIMITED TO, IMPLIED WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, AND NON-INFRINGEMENT.
          </Normal>
          <div className="p-3" />
          <Normal>
            WE DO NOT WARRANT THAT:
            <br />- OUR SERVICES WILL BE UNINTERRUPTED, TIMELY, SECURE, OR ERROR-FREE
            <br />- ANY INFORMATION OBTAINED FROM OUR SERVICES WILL BE ACCURATE OR RELIABLE
            <br />- ANY DEFECTS IN OUR SERVICES WILL BE CORRECTED
            <br />- OUR SERVICES WILL MEET YOUR REQUIREMENTS OR EXPECTATIONS
            <br />- OUR SERVICES WILL BE COMPATIBLE WITH ANY THIRD-PARTY SOFTWARE OR SERVICES
          </Normal>
          <div className="p-3" />
          <Normal>
            YOU ACKNOWLEDGE AND AGREE THAT YOUR USE OF OUR SERVICES IS AT YOUR SOLE RISK. YOU ASSUME FULL RESPONSIBILITY AND RISK OF LOSS RESULTING FROM YOUR USE OF OUR SERVICES.
          </Normal>
          <div className="p-5" />

          <Title>13. Limitation of Liability</Title>
          <div className="p-3" />
          <Normal>
            TO THE MAXIMUM EXTENT PERMITTED BY APPLICABLE LAW, CODEBLAZE AND ITS AFFILIATES, OFFICERS, EMPLOYEES, AGENTS, PARTNERS, AND LICENSORS WILL NOT BE LIABLE FOR ANY INDIRECT, INCIDENTAL, SPECIAL, CONSEQUENTIAL, OR PUNITIVE DAMAGES, OR ANY LOSS OF PROFITS, REVENUE, DATA, OR USE, INCURRED BY YOU OR ANY THIRD PARTY, WHETHER IN AN ACTION IN CONTRACT, TORT, OR OTHERWISE, ARISING FROM YOUR ACCESS TO OR USE OF OUR SERVICES.
          </Normal>
          <div className="p-3" />
          <Normal>
            OUR TOTAL LIABILITY FOR ANY CLAIMS ARISING OUT OF OR RELATING TO THESE TERMS OR YOUR USE OF OUR SERVICES IS LIMITED TO THE AMOUNT YOU HAVE PAID US IN THE LAST TWELVE (12) MONTHS.
          </Normal>
          <div className="p-3" />
          <Normal>
            THE FOREGOING LIMITATIONS WILL APPLY EVEN IF THE ABOVE STATED REMEDY FAILS OF ITS ESSENTIAL PURPOSE.
          </Normal>
          <div className="p-5" />

          <Title>14. Indemnification</Title>
          <div className="p-3" />
          <Normal>
            You agree to indemnify, defend, and hold harmless Codeblaze and our affiliates, officers, employees, agents, partners, and licensors from and against any and all claims, liabilities, damages, losses, or expenses, including reasonable attorneys' fees and costs, arising out of or in any way connected with:
            <br />- Your access to or use of our Services
            <br />- Your violation of these Terms
            <br />- Your infringement of any third-party rights
            <br />- Any content you submit or share through our Services
            <br />- Any applications, websites, or services you create using our Services
          </Normal>
          <div className="p-5" />

          <Title>15. Governing Law and Dispute Resolution</Title>
          <div className="p-3" />
          <Big>15.1 Governing Law</Big>
          <div className="p-3" />
          <Normal>
            These Terms and any disputes arising out of or related to them or your use of our Services will be governed by and construed in accordance with the laws of the State of Delaware, without regard to its conflict of laws principles.
          </Normal>
          <div className="p-3" />
          <Big>15.2 Dispute Resolution</Big>
          <div className="p-3" />
          <Normal>
            Any legal action or proceeding arising out of or relating to these Terms or your use of our Services will be brought exclusively in the federal or state courts located in Delaware, and you consent to the personal jurisdiction of those courts.
          </Normal>
          <div className="p-3" />
          <Big>15.3 Arbitration</Big>
          <div className="p-3" />
          <Normal>
            For any dispute arising out of or relating to these Terms or your use of our Services, you agree to first contact us and attempt to resolve the dispute with us informally. If we are unable to resolve the dispute informally, we each agree to resolve any claim, dispute, or controversy by binding arbitration. The arbitration will be conducted by a neutral arbitrator and will be held in Dover, Delaware.
          </Normal>
          <div className="p-5" />

          <Title>16. General Provisions</Title>
          <div className="p-3" />
          <Big>16.1 Assignment</Big>
          <div className="p-3" />
          <Normal>
            You may not assign or transfer these Terms or your rights under these Terms without our prior written consent. We may assign or transfer these Terms or our rights under these Terms without your consent.
          </Normal>
          <div className="p-3" />
          <Big>16.2 Waiver</Big>
          <div className="p-3" />
          <Normal>
            Our failure to enforce any right or provision of these Terms will not be considered a waiver of those rights. If any provision of these Terms is held to be invalid or unenforceable by a court, the remaining provisions of these Terms will remain in effect.
          </Normal>
          <div className="p-3" />
          <Big>16.3 Severability</Big>
          <div className="p-3" />
          <Normal>
            If any provision of these Terms is found to be invalid or unenforceable, the remaining provisions will remain in full force and effect.
          </Normal>
          <div className="p-3" />
          <Big>16.4 Entire Agreement</Big>
          <div className="p-3" />
          <Normal>
            These Terms constitute the entire agreement between you and us regarding your use of our Services and supersede all prior agreements between you and us.
          </Normal>
          <div className="p-3" />
          <Big>16.5 Force Majeure</Big>
          <div className="p-3" />
          <Normal>
            We will not be liable for any failure or delay in our performance under these Terms due to any cause beyond our reasonable control, including but not limited to acts of God, acts of civil or military authorities, fires, floods, earthquakes, wars, strikes, or other labor disputes.
          </Normal>
          <div className="p-5" />

          <Title>17. Contact Us</Title>
          <div className="p-3" />
          <Normal>
            If you have any questions about these Terms, please contact us at:
          </Normal>
          <div className="p-3" />
          <Normal>
            Codeblaze AI Inc.
            <br />Dover, DE 19904
            <br />USA
          </Normal>
          <div className="p-3" />
          <Normal>
            Email: feedback@codeblaze.ai
          </Normal>
          <div className="p-7" />

          <Normal>
            By using our Services, you acknowledge that you have read and understood these Terms of Service and agree to be bound by them.
          </Normal>
        </div>
      </div>
    </div>
  );
};

export default Term;
